import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

import { Tooltip } from "../../../tooltip/Tooltip";
import { Icon } from "../../../icon/Icon";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";
import { widgetTitles } from "../widgetTitles";
import { DrilldownKeys } from "../../../../helpers/reports.helper.types";

interface WidgetHeaderProps {
  id: DrilldownKeys;
}

export const WidgetHeader = ({ id }: WidgetHeaderProps) => {
  return (
    <Fragment>
      <span aria-hidden={true}>
        <Mobile>
          <FormattedMessage id={widgetTitles[id].short} />
        </Mobile>
        <NotMobile>
          <span>
            <FormattedMessage id={widgetTitles[id].long} />
          </span>
          <Tooltip
            content={<FormattedMessage id={`${id}_tooltip_description`} />}
          >
            <Icon icon="fa-regular fa-question-circle" />
          </Tooltip>
        </NotMobile>
      </span>
      <div className="sr-only">
        <FormattedMessage id={`${id}_tooltip_description`} />
      </div>
    </Fragment>
  );
};
